import { Button } from '../../primitives/Button.js';
import { Group } from '../../primitives/Group.js';
import styles from './DataTable.module.css';

export function DataTablePaginationBar({
  total,
  pageIndex,
  pageCount,
  onPrev,
  onNext,
}: {
  total: number;
  pageIndex: number;
  pageCount: number;
  onPrev: () => void;
  onNext: () => void;
}) {
  const current = total === 0 ? 0 : pageIndex + 1;
  const count = total === 0 ? 0 : pageCount;
  const hasPreviousView = total > 0 && pageIndex > 0;
  const hasNextView = total > 0 && pageIndex < pageCount - 1;
  return (
    <nav className={styles.paginationBar} aria-label="Pagination du tableau">
      <Group gap="md" wrap="nowrap" align="center">
        <Button type="button" variant="soft" size="xs" disabled={!hasPreviousView} onClick={onPrev}>
          Précédent
        </Button>
        <span className={styles.paginationMeta} aria-live="polite" aria-atomic="true">
          <span className={total === 0 ? styles.paginationMuted : styles.paginationCurrent}>{current}</span>
          <span className={styles.paginationSep} aria-hidden>
            /
          </span>
          <span className={styles.paginationMuted}>{count}</span>
        </span>
        <Button type="button" variant="soft" size="xs" disabled={!hasNextView} onClick={onNext}>
          Suivant
        </Button>
      </Group>
    </nav>
  );
}
